/* Returns the user's active kiwi skin (used as app logo in sidebar). */

import { useQuery } from "convex/react";
import { api } from "../../convex/_generated/api";
import type { KiwiSkinConfig } from "@/types/kiwiSkin";

export function useActiveKiwiSkin() {
  const activeSkin = useQuery(api.kiwiSkins.getActiveSkin) as KiwiSkinConfig | null | undefined;
  const isLoading = activeSkin === undefined;
  return { activeSkin, isLoading };
}
